MainContextProvider;

import { Theme } from "@mui/material";
import React, { Dispatch, SetStateAction, useEffect, useState } from "react";
import { darkTheme, darkThemeTwo, lightTheme, lightThemeTwo } from "../themes/themes";
import {
  UsinaByClient,
  RelatorioDiarioData,
  RelatorioMensalData,
  RelatorioPersonalizadoData,
  RelatorioParcialData,
} from "../../modules/usinas/types";
import { resourcesApi, usersApi, usinasApi } from "../../services/api";
import { UserRoles, type User as UsersUser } from "../../modules/users/types";
import { Recurso } from "../../modules/dashboard/types";

export type AppTheme = {
  name: string;
  muiTheme: Theme;
  backgroundColor?: string;
  backgroundScreenColor?: string;
  backgroundImage?: string;
  cardsDefaultBgColor?: string;
  headerMenuBgColor?: string;
  headerMenuBgImage?: string;
  iconsColor?: string;
  primaryTextColor?: string;
  secondaryTextColor?: string;
  cardArrowsColor?: string;
  cardBorderColor?: string;
  cardBoxBackgroudColor?: string
  asideMenuBackgroundColor?: string
};

export type User = {
  clientIdAndName: { id: string; name: string }[];
  userId: string;
  name?: string;
  email?: string;
  phone?: string;
  acceptedTerms: boolean;
  usinasIds: string[];
  roles: string[];
  passwordReseted: boolean;
  userAccessToken: string;
  expiration: Date;
  created: Date;
  hasAllAccess: boolean;
  resetLayout?: boolean
};

export type ToastNotifications = {
  isAdding: boolean;
  notifications: {
    text: React.ReactNode;
    severity: "error" | "warning" | "info" | "success";
  }[];
};

export type usinasIdAndDateLoading = {
  usinaId: string, date: string, interval: number
}

export enum LayoutsConfig {
  LayoutOne = "LayoutOne",
  LayoutTwo = "LayoutTwo"
}


type MainContextType = {
  theme: AppTheme;
  setTheme: (theme: AppTheme) => void;
  info: {
    date: string;
    time: string;
    value: string;
  };
  setInfo: (info: { date: string; time: string; value: string }) => void;
  userIsLogged?: boolean;
  user?: User;
  setUser: (user: User | undefined) => void;
  userIsAdm: boolean;
  userIsClient: boolean;
  userIsManutencao: boolean;
  selectedClientIsJustManutencao: boolean;
  screenWidth: number;
  bodyWidth: number;
  setScreenWidth: (screenWidth: number) => void;
  asideMenuIsShrunken: boolean;
  setAsideMenuIsShrunken: (isShrunken: boolean) => void;
  asideMenuWidth: number;
  isMobile: boolean;
  bodyHeight: number;
  screenHeight: number;
  setScreenHeight: (screenHeight: number) => void;
  bottomMenuHeight: number;
  selectedDashboardUsina: UsinaByClient | undefined;
  setSelectedDashboardUsina: (usina: UsinaByClient | undefined) => void;
  selectedDashboardClient: { id: string; name: string } | undefined;
  setSelectedDashboardClient: (usina: { id: string; name: string } | undefined) => void;

  clientUsinas: UsinaByClient[];
  userClients: { id: string; name: string }[] | undefined;

  userDetails: UsersUser | null;

  showBlipChat: boolean;
  setShowBlipChat: (show: boolean) => void;
  toastNotifications: ToastNotifications;
  setToastNotifications: (toastNotifications: ToastNotifications | ((prevState: ToastNotifications) => ToastNotifications)) => void;
  isLoadingDashboard: boolean;
  setIsLoadingDashboard: Dispatch<SetStateAction<boolean>>;
  relatorioDiario: RelatorioDiarioData | null;
  setRelatorioDiario: (relatorioDiario: RelatorioDiarioData) => void;
  relatorioDiarioLoading: boolean;
  setRelatorioDiarioLoading: Dispatch<SetStateAction<boolean>>;

  relatorioPersonalizado: RelatorioPersonalizadoData | null;
  setRelatorioPersonalizado: (relatorioPersonalizado: RelatorioPersonalizadoData) => void;
  relatorioPersonalizadoLoading: boolean;
  setRelatorioPersonalizadoLoading: Dispatch<SetStateAction<boolean>>;

  relatorioMensal: RelatorioMensalData | null;
  setRelatorioMensal: (relatorioMensal: RelatorioMensalData) => void;
  relatorioMensalLoading: boolean;
  setRelatorioMensalLoading: Dispatch<SetStateAction<boolean>>;

  relatorioParcial: RelatorioParcialData | null;
  setRelatorioParcial: (relatorioParcial: RelatorioParcialData) => void;
  relatorioParcialLoading: boolean;
  setRelatorioParcialLoading: Dispatch<SetStateAction<boolean>>;

  isLoadingClientUsinas: boolean;
  setisLoadingClientUsinas: Dispatch<SetStateAction<boolean>>;
  usinasIdsLoading: usinasIdAndDateLoading[] | undefined;
  setUsinasIdsLoading: Dispatch<
    SetStateAction<usinasIdAndDateLoading[] | undefined>
  >;
  layout: LayoutsConfig;
  setLayout: Dispatch<
    SetStateAction<LayoutsConfig>
  >;
  clientMenuResources: Recurso[]
  setClientMenuResources: React.Dispatch<React.SetStateAction<Recurso[]>>
};

// relatorioPersonalizadoLoading,
// relatorioPersonalizado,
// setRelatorioPersonalizadoLoading,
// setRelatorioPersonalizado,

const defaultValue: MainContextType = {
  theme: {
    name: "",
    muiTheme: {} as Theme,
  },
  setTheme: () => { },
  info: {
    date: "",
    time: "",
    value: "",
  },
  setInfo: () => { },
  userIsLogged: false,
  user: undefined,
  setUser: () => { },
  userIsAdm: true,
  userIsClient: true,
  userIsManutencao: true,
  selectedClientIsJustManutencao: true,
  screenWidth: 0,
  bodyWidth: 0,
  setScreenWidth: () => { },
  asideMenuIsShrunken: false,
  setAsideMenuIsShrunken: () => { },
  asideMenuWidth: 0,
  isMobile: false,
  bodyHeight: 0,
  screenHeight: 0,
  setScreenHeight: () => { },
  bottomMenuHeight: 0,
  selectedDashboardUsina: undefined,
  setSelectedDashboardUsina: () => { },
  selectedDashboardClient: undefined,
  setSelectedDashboardClient: () => { },

  clientUsinas: [],
  userClients: undefined,

  userDetails: null,

  showBlipChat: false,
  setShowBlipChat: () => { },
  toastNotifications: {
    isAdding: false,
    notifications: [],
  },
  setToastNotifications: () => { },
  isLoadingDashboard: false,
  setIsLoadingDashboard: () => { },
  relatorioDiario: null,
  setRelatorioDiario: () => { },
  relatorioDiarioLoading: false,
  setRelatorioDiarioLoading: () => { },
  relatorioPersonalizado: null,
  setRelatorioPersonalizado: () => { },
  relatorioPersonalizadoLoading: false,
  setRelatorioPersonalizadoLoading: () => { },
  relatorioMensal: null,
  setRelatorioMensal: () => { },
  relatorioMensalLoading: false,
  setRelatorioMensalLoading: () => { },
  relatorioParcial: null,
  setRelatorioParcial: () => { },
  relatorioParcialLoading: false,
  setRelatorioParcialLoading: () => { },
  isLoadingClientUsinas: false,
  setisLoadingClientUsinas: () => { },
  setUsinasIdsLoading: () => { },
  usinasIdsLoading: [],
  layout: LayoutsConfig.LayoutOne,
  setLayout: () => { },
  clientMenuResources: [],
  setClientMenuResources: () => { },
};

export const MainContext = React.createContext(defaultValue);

export default function MainContextProvider(props: {
  children: React.ReactNode;
}) {
  const [showBlipChat, setShowBlipChat] = useState<boolean>(false);
  function getUser() {
    const user = localStorage.getItem("user");
    if (user) {
      return JSON.parse(user);
    }
  }
  const [toastNotifications, setToastNotifications] =
    useState<ToastNotifications>({ isAdding: false, notifications: [] });

  const [layout, setLayout] =
    useState<LayoutsConfig>(LayoutsConfig.LayoutTwo);

  const [user, setUser] = useState<User | undefined>(getUser());

  const userIsLogged = user ? true : false;
  const userIsClient =
    user &&
      user.roles?.find(
        (role) => role == UserRoles.Client || role == UserRoles.ClientAdm
      )
      ? true
      : false;
  const userIsAdm =
    user && user.roles?.find((role) => role == UserRoles.Admin) ? true : false;
  const userIsManutencao =
    user && user.roles?.find((role) => role == UserRoles.Maintenance)
      ? true
      : false;
  const uniqueRoles = Array.from(new Set(user?.roles))
  const selectedClientIsJustManutencao =
    user && uniqueRoles.length == 2 && uniqueRoles.find((role) => role == UserRoles.Maintenance) && uniqueRoles.find((role) => role == UserRoles.User)
      ? true
      : false;
  const [sseInfo, setSSEInfo] = useState<{
    date: string;
    time: string;
    value: string;
  }>({
    date: "19/06/2023",
    time: "17:00:00",
    value: "0.95",
  });
  const [screenWidth, setScreenWidth] = useState<number>(window.innerWidth);

  useEffect(() => {
    const updateScreenWidth = () => {
      setScreenWidth(window.innerWidth);
    };
    window.addEventListener("resize", updateScreenWidth);
    return () => {
      window.removeEventListener("resize", updateScreenWidth);
    };
  }, []);

  const [screenHeight, setScreenHeight] = useState<number>(window.innerHeight);
  useEffect(() => {
    const updateScreenHeight = () => {
      setScreenHeight(window.innerHeight);
    };
    window.addEventListener("resize", updateScreenHeight);
    return () => {
      window.removeEventListener("resize", updateScreenHeight);
    };
  }, []);

  // useEffect(() => {
  //   localStorage.setItem("user", JSON.stringify(user ?? ""));
  //   if (user?.clientIdAndName && user?.clientIdAndName.length > 0) {
  //     setSelectedClient(user?.clientIdAndName[0]);
  //   } else {
  //     setIsLoadingDashboard(false);
  //   }

  //   // Adicionando log das roles
  //   console.log("Roles do usuÃ¡rio:", user?.roles);
  // }, [user]);

  const path = window.location.pathname;

  const [selectedDashboardUsina, setSelectedDashboardUsina] = React.useState<
    UsinaByClient | undefined
  >();

  const getHeaderHeightValue = () => {
    switch (path) {
      case "/dashboard":
      case "/operations/center":
      case "/portfolio":
      case "/operations/control":
      case "/alarm/equipment-alarms-list":
      case "/service-request/list":
      case `/usinas/details/${selectedDashboardUsina?.usinaIds.id}`:
      case "/usinas/boletim-diario":
      case "/usinas/boletim-mensal":
      case "/usinas/boletim-personalizado":
      case "/usinas/boletim-parcial":
        return 84;
      default:
        return 42;
    }
  }

  const isMobile = screenWidth < 600;
  const bottomMenuHeight = isMobile ? 56 : 0;
  const bodyHeight = !isMobile && layout == LayoutsConfig.LayoutTwo ? (screenHeight - bottomMenuHeight) - getHeaderHeightValue() : screenHeight - bottomMenuHeight;
  const [asideMenuIsShrunken, setAsideMenuIsShrunken] =
    useState<boolean>(false);
  const asideMenuWidth = isMobile ? 0 : asideMenuIsShrunken ? (layout == LayoutsConfig.LayoutOne ? 60 : 42) : (layout == LayoutsConfig.LayoutOne ? 240 : 222);
  const bodyWidth = screenWidth - asideMenuWidth;
  // useEffect(() => {
  //   const queryString = "?token=" + user?.userAccessToken;

  //   const SSEUrl = import.meta.env.VITE_SSE_URL as string;
  //   const eventSource = new EventSource(SSEUrl + queryString);
  //   eventSource.onmessage = (event) => {
  //     const newData = event.data;
  //     const newInfo = getInfoFromData(newData);
  //     setSSEInfo(newInfo);
  //   };
  //   return () => {
  //     eventSource.close();
  //   };
  // }, [user]);
  const savedTheme = localStorage.getItem("theme");

  const [theme, setTheme] = useState<AppTheme>(getTheme());
  const [isLoadingDashboard, setIsLoadingDashboard] = React.useState(true);
  const [isLoadingClientUsinas, setisLoadingClientUsinas] =
    React.useState(true);


  function getTheme() {
    if (savedTheme) {
      if (savedTheme === "dark") {
        return layout == LayoutsConfig.LayoutOne ? darkTheme : darkThemeTwo;
      } else {
        return layout == LayoutsConfig.LayoutOne ? lightTheme : lightThemeTwo;
      }
    } else {
      return layout == LayoutsConfig.LayoutOne ? darkTheme : darkThemeTwo;
    }
  }

  useEffect(() => {
    setTheme(getTheme())
  }, [layout])

  useEffect(() => {
    localStorage.setItem("theme", theme.name);
  }, [theme]);

  useEffect(() => {
    if (!user) {
      localStorage.removeItem("clientId");
      localStorage.removeItem("usinaId");
    }
    localStorage.setItem("user", JSON.stringify(user ?? ""));
    if (!localStorage.getItem("clientId") && user?.clientIdAndName && user?.clientIdAndName.length > 0) {
      setSelectedDashboardClient(user?.clientIdAndName[0]);
    }
    else if (localStorage.getItem("clientId") && user?.clientIdAndName && user?.clientIdAndName.length > 0) {
      var localStorageClient = user?.clientIdAndName.find((client) => client.id == localStorage.getItem("clientId"))
      setSelectedDashboardClient(localStorageClient);
    }
    else {
      setIsLoadingDashboard(false);
    }
  }, [user]);

  const [selectedDashboardClient, setSelectedDashboardClient] = React.useState<
    { id: string; name: string } | undefined
  >();

  const [clientUsinas, setClientUsinas] = useState<UsinaByClient[]>([]);

  const getClientUsinas = async () => {
    if (selectedDashboardClient) {
      try {
        setisLoadingClientUsinas(true);
        setIsLoadingDashboard(true);
        const usinasResponse = await usinasApi.getUsinasByClientId(
          selectedDashboardClient?.id
        );
        setClientUsinas(usinasResponse.data);
        usinasResponse.data &&
          usinasResponse.data.length > 0 &&
          setSelectedDashboardUsina(usinasResponse.data[0]);
        localStorage.setItem("usinaId", usinasResponse.data[0].usinaIds.id);

        if (usinasResponse.data.length === 0) {
          setToastNotifications({
            isAdding: true,
            notifications: [
              {
                text: "Cliente sem usinas cadastradas",
                severity: "warning",
              },
            ],
          });
        }
      } catch (error) {
        console.error("Erro ao carregar usinas do Cliente");
      } finally {
        setIsLoadingDashboard(false);
        setisLoadingClientUsinas(false);
      }
    } else {
      setisLoadingClientUsinas(false);
    }
  };
  //TODO: o acesso ao menu de centro de operações foi hardcoded temporariamente para apresentação do novo módulo, devemos atualizar os bancos de acordo com os perfis que devem acessar, e remover a escrita hardcoded
  const operationCenterResource: Recurso = {
    isEnabled: true,
    name: "Centro de Operações Solar",
    requires2FactorAuthentication: false,
    type: "MENU",
    uri: "/operations/center"
  }
  const [clientMenuResources, setClientMenuResources] = useState<Recurso[]>([])

  const GetMenuRecursos = async () => {
    if (selectedDashboardClient?.id) {
      const menuResourcesResponse = await resourcesApi.getMenuResourcesByClientId(selectedDashboardClient?.id)
      setClientMenuResources(menuResourcesResponse.concat(operationCenterResource))
    }
  }

  useEffect(() => {
    GetMenuRecursos()
  }, [selectedDashboardClient])

  useEffect(() => {
    user &&
      selectedDashboardClient &&
      localStorage.setItem("clientId", selectedDashboardClient?.id);
    getClientUsinas();
  }, [selectedDashboardClient]);

  const userClients = user?.clientIdAndName;

  const [userDetails, setUserDetails] = useState<UsersUser | null>(null);

  const getUserClusters = async () => {
    if (user) {
      try {
        const userResponse = await usersApi.getUser(
          user.userId
        );
        setUserDetails(userResponse);
      } catch (error) {
        console.error("Erro ao carregar clusters do Usuário");
      }
    }
  }

  useEffect(() => {
    getUserClusters();
  }, [selectedDashboardUsina]);


  const [relatorioDiario, setRelatorioDiario] =
    useState<RelatorioDiarioData | null>(null);

  const [relatorioDiarioLoading, setRelatorioDiarioLoading] =
    useState<boolean>(false);

  const [relatorioPersonalizado, setRelatorioPersonalizado] =
    useState<RelatorioPersonalizadoData | null>(null);

  const [relatorioPersonalizadoLoading, setRelatorioPersonalizadoLoading] =
    useState<boolean>(false);

  const [relatorioMensal, setRelatorioMensal] =
    useState<RelatorioMensalData | null>(null);

  const [relatorioMensalLoading, setRelatorioMensalLoading] =
    useState<boolean>(false);

  const [relatorioParcial, setRelatorioParcial] =
    useState<RelatorioParcialData | null>(null);

  const [relatorioParcialLoading, setRelatorioParcialLoading] =
    useState<boolean>(false);

  const [usinasIdsLoading, setUsinasIdsLoading] =
    useState<usinasIdAndDateLoading[]>();

  return (
    <MainContext.Provider
      value={{
        theme,
        setTheme,
        info: sseInfo,
        setInfo: setSSEInfo,
        userIsLogged,
        user,
        setUser,
        userIsAdm,
        userIsClient,
        userIsManutencao,
        selectedClientIsJustManutencao,
        asideMenuIsShrunken,
        setAsideMenuIsShrunken,
        asideMenuWidth,
        screenWidth,
        bodyWidth,
        setScreenWidth,
        isMobile,
        bodyHeight,
        screenHeight,
        setScreenHeight,
        bottomMenuHeight,
        selectedDashboardUsina,
        setSelectedDashboardUsina,
        selectedDashboardClient,
        setSelectedDashboardClient,

        clientUsinas,
        userClients,

        userDetails,

        showBlipChat,
        setShowBlipChat,
        toastNotifications,
        setToastNotifications,
        isLoadingDashboard,
        setIsLoadingDashboard,
        relatorioDiario,
        setRelatorioDiario,
        relatorioDiarioLoading,
        setRelatorioDiarioLoading,
        relatorioPersonalizado,
        setRelatorioPersonalizado,
        relatorioPersonalizadoLoading,
        setRelatorioPersonalizadoLoading,
        relatorioMensal,
        setRelatorioMensal,
        relatorioMensalLoading,
        setRelatorioMensalLoading,
        relatorioParcial,
        setRelatorioParcial,
        relatorioParcialLoading,
        setRelatorioParcialLoading,
        isLoadingClientUsinas,
        setisLoadingClientUsinas,
        usinasIdsLoading,
        setUsinasIdsLoading,
        layout,
        setLayout,
        clientMenuResources,
        setClientMenuResources,
      }}
    >
      {props.children}
    </MainContext.Provider>
  );
}
